import { mapState, mapMutations } from 'vuex';
import { handleErrors } from '@H/outerErrors';

export default {
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            submittedOnce: false,
            isValid: false,
            silently: false,
            unwatch: null
        };
    },
    mounted() {
        this.initFields(this.$validator.fields.items);
        this.errorBagWatch();
    },
    computed: {
        ...mapState(['formSubmitting', 'bus'])
    },
    methods: {
        ...mapMutations(['setFormSubmitting']),
        errorBagWatch() {
            if (this.unwatch == null) {
                this.unwatch = this.$watch('errors', errorBag => {
                    if (errorBag.items && errorBag.items.length > 0) {
                        const target = this.$el.querySelector(`[name="${errorBag.items[0].field}"]`);
                        if (target) {
                            this.$nextTick(() => {
                                target.scrollIntoView();
                                this.unwatch();
                                this.unwatch = null;
                            });
                        }
                    }
                }, {
                    deep: true
                });
            }
        },
        validate() {
            this.$validator
                .validate('*', null, { silent: this.silently })
                .then(result => (this.isValid = result));
        },
        async initFields(fields) {
            if (fields.length) {
                for (let field of fields) {
                    const el = field.el;
                    const eventType =
                        el.type == 'checkbox'
                            ? ['change']
                            : ['keyup', 'change'];

                    for (let type of eventType) {
                        el.addEventListener(type, async _ => {
                            if (this.submittedOnce) {
                                await this.validate();
                            }
                        });
                    }
                }
            }
        },
        handleForm(e) {
            e.preventDefault();
            if (!this.formSubmitting) {
                this.errorBagWatch();
                if (!this.submittedOnce) {
                    this.submittedOnce = true;
                }
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    this.setFormSubmitting(true);
                    this.checkFormHandler(e);
                });
            }
        },
        checkFormHandler(e) {
            if (this.formHandler) {
                this.formHandler(e);
            } else {
                this.bus.$emit('form:submit', e);
            }
        },
        handleOuterErrors(errs) {
            handleErrors(this, errs);
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/validationWrapper.js